/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    EditProfileData: null,
    EditProfileStatus: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.EditProfileAction.REQUEST_EDITPROFILEDATA:
      return {
        ...state
      };
    case actions.EditProfileAction.EDITPROFILEDATA_RECEIVED:
      return {
        ...state,
        EditProfileData: action.data,
        EditProfileStatus : action.data.Status
      };
      case actions.EditProfileAction.CLEAR_EDITPROFILEDATA:
        return {
          ...state,
          EditProfileStatus: null
        };

    default:
      return state;
  }
};

export default reducer;
